import { Action, ActionType } from "models/contract/inquiryDetail";
import { IResponse } from "models";
import createReducer from "../../createReducer";

export interface InquiryDetailReducerType {
  loading: boolean;
  error?: string;
  inquiryDetailResponse?: IResponse;
}

const defaultState: InquiryDetailReducerType = {
  loading: false,
  error: undefined,
  inquiryDetailResponse: undefined,
};

export const sendInquiryDetailReducer = createReducer<InquiryDetailReducerType>(
  defaultState,
  {
    [ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL](
      state: InquiryDetailReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL_ERROR](
      state: InquiryDetailReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL_SUCCESS](
      state: InquiryDetailReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        inquiryDetailResponse: action.payload,
      };
    },

    [ActionType.CONTRACT_INFORMATION_INQUIRY_DETAIL_RESET](
      state: InquiryDetailReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        inquiryDetailResponse: undefined,
      };
    },
  }
);
